<template>
  <div class="chartWidget">
    <div class="container">
      <div class="panel panel-primary">
        <div v-if="showSettings" class="row grid-x flex-nowrap" style="margin-top: 10px;margin-bottom: 10px;">
          <div class="col-md-3 left-col">
            <button class="btn btn-outline-primary" @click="toggleShowSettings" style="width: 190px;">
              {{ hideSettingsText }}
            </button>
          </div>
          <div class="clearfix" />
        </div>
        <div v-else style="margin-top: 10px;margin-bottom: 10px;">
          <button class="btn btn-outline-primary" @click="toggleShowSettings" style="width: 190px;">
            {{ showSettingsText }}
          </button>
        </div>
        <div class="panel-heading" v-if="showSettings">
          <ul class="nav panel-tabs">
            <li
              :class="[chartType === type ? 'active' : '']"
              v-for="(type, idx) in chartTypes"
              :key="idx"
            >
              <a
                :href="`#tab-${type}${widgetKey}`"
                data-toggle="tab"
                @click.prevent="setActive(type)"
              >
                {{ type | capitalize }}
              </a>
            </li>
          </ul>
        </div>
        <div class="panel-body">
          <div class="tab-content">
            <div
              class="tab-pane"
              v-for="(type, idx) in chartTypes"
              :key="idx"
              :class="[chartType === type ? 'active' : '']"
              :id="`tab-${type}${widgetKey}`"
            >
              <div style="height: 100%;width: 100%;margin: 0 auto;">
                <div class="row" v-if="showSettings">
                  <div class="col-md-6">
                    <label>Label</label>
                    <div
                      v-for="(em, key1) in labelNewForChart"
                      :key="key1"
                    >
                      <select
                        v-model="labelForChart"
                        class="select-label-data"
                        @change="optionsItemChanged"
                      >
                        <option
                          v-for="(e, key2) in em"
                          :key="key2"
                          :value="e"
                        >
                          {{e}}
                        </option>
                      </select>
                      <select
                           v-model="label2ForChart"
                           class="select-label-data"
                           @change="optionsItemChanged"
                      >
                        <option
                          v-for="(e, key2) in em"
                          :key="key2"
                          :value="e"
                        >
                          {{e}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label>Data</label>
                    <div
                      v-for="(em, key1) in dataNewForChart"
                      :key="key1"
                    >
                      <select
                        v-model="dataForChart"
                        class="select-label-data"
                        @change="optionsItemChanged"
                      >
                        <option
                          v-for="(e, key2) in em"
                          :key="key2"
                          :value="e"
                        >
                          {{ e }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div
                  class="chartWidget__chartWrapper"
                  v-if="isReady"
                >
                  <Pie
                    :chart-data="datacollection"
                    :options="options"
                    v-if="type === 'pie'"
                  />
                  <Bar
                    :chart-data="datacollection"
                    :options="optionsByBar"
                    v-if="type === 'bar'"
                  />
                  <LineCharts
                    :chart-data="dataByLine"
                    :options="optionsByLine"
                    v-if="type === 'line'"
                  />
                  <Donut
                    :chart-data="datacollection"
                    :options="options"
                    v-if="type === 'donut'"
                  />
                  <StackedBar
                    :chart-data="datacollectionByStacked"
                    :options="optionsByStacked"
                    v-if="type === 'stacked'"
                  />
                  <Multiple
                    :chart-data="datacollectionByStacked"
                    :options="optionsByMultiple"
                    v-if="type === 'multiple'">
                  </Multiple>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import 'chartjs-plugin-datalabels'
  import Pie from './pie.js'
  import Bar from './bar.js'
  import Donut from './donut.js'
  import LineCharts from './line.js'
  import StackedBar from './stackedBar'
  import Multiple from './multiple'
  import { groupBy, sumBy, fill, forEach, map } from 'lodash'
  import randomColor from 'randomcolor'
  // services
  import db from '@/services/db'
import { setTimeout } from 'timers';

  const $ = window.$

  export default {
    components: {
      Pie,
      Bar,
      Donut,
      StackedBar,
      LineCharts,
      Multiple
    },
    props: {
      rData: {
        type: Array,
        required: true
      },
      chartId: {
        type: String,
        required: true
      },
      widgetKey: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        reportData: this.rData,
        dataForChart: null,
        showSettingsText: 'Show settings',
        hideSettingsText: 'Hide settings',
        showSettings: false,
        labelForChart: null,
        label2ForChart: null,
        datacollection: null,
        optionsByLine: null,
        dataByLine: null,
        datacollectionByStacked: null,
        options: null,
        optionsByBar: null,
        optionsByStacked: null,
        optionsByMultiple: null,
        dataNewForChart: [],
        labelNewForChart: [],
        labellabel: [],
        isPie: true,
        isDonut: false,
        isBar: false,
        isStacked: false,
        isMultiple: false,
        isLine: false,
        chartType: 'bar',
        chartTypes: [
          'pie',
          'bar',
          'donut',
          'stacked',
          'line',
          'multiple'
        ],
        rows: [],
        label:[],
        labelStacked: [],
        dataStacked: [],
        data: [],
        background: [],
        colors: [
          '#ff9f40',
          '#36a2eb',
          '#ff6384',
          '#ffcd56',
          '#4bc0c0',
          '#6f40fe',
        ],
        isReady: false
      }
    },
    watch: {
      labelForChart () {
        this.checkIsRequiredDataFilled()
      },
      dataForChart () {
        this.checkIsRequiredDataFilled()
      },
      label2ForChart () {
        this.checkIsRequiredDataFilled()
      }
    },
    methods: {
      toggleShowSettings: function() {
        this.showSettings = !this.showSettings
      },
      checkIsRequiredDataFilled () {
        if (this.labelForChart && this.dataForChart && this.label2ForChart) {
          this.isReady = true
          this.fillData()
        } else {
          this.isReady = false
        }
      },
      optionsItemChanged () {
        const vm = this
        const data = {
          label: vm.labelForChart,
          label2: vm.label2ForChart,
          data: vm.dataForChart
        }
        db.chart.setNewLablesAndData(this.chartId, data)
      },
      loadData () {
        if (this.colors.length < this.rData.length) {
          let count = this.rData.length - this.colors.length
          let color = randomColor({
            count: count,
            luminosity: 'light',
            hue: 'random'
          })
          this.colors = this.colors.concat(color)
        }

        this.label = []
        this.labelStacked = []
        this.data = []
        this.dataStacked = []
        this.background = []
        let arr = this.reportData
        let chartSettings = {}

        chartSettings = {
          label: this.labelForChart,
          type: this.chartType,
          data: this.dataForChart,
          label2: this.label2ForChart,
        }

        var Charts = {
          setOrder: [
            'danger', 'default', 'success',
            'primary', 'info', 'secondary',
            'first', 'second', 'four', 'five',
            'six', 'seven', 'nine', 'ten',
            'info2', 'info3', 'info4'
          ],
          colors: {
            theme: {
              'default': '#ff9f40',
              'primary': '#36a2eb',
              'secondary': '#ff6384',
              'info': '#ffcd56',
              'success': '#4bc0c0',
              'danger': '#6f40fe',
              'first': '#fe85d0',
              'second': '#f7febd',
              'four': '#65fef2',
              'five': '#fee0f2',
              'six': '#03feb7',
              'seven': '#c9fe91',
              'nine': '#a465fe',
              'ten': '#3f2cfe',
              'info2': '#fea8ab',
              'info3': '#fe8d61',
              'info4': '#9c0965'
            }
          }
        }
        const ans = _(arr).groupBy(this.labelForChart)
                .map((platform, n) => ({
                  [this.labelForChart]: n,
                  [this.dataForChart]: _.sumBy(platform, this.dataForChart)
                }))
                .value()
        let arr_level1 = groupBy(arr, this.labelForChart)
        let arr_level2 = map(arr_level1, d => {
          return groupBy(d, this.label2ForChart)
        })
        let obgOp = _(arr_level2).map((outer, inner) => (
                map(outer, (data, label) => ({
                  [this.label2ForChart]: label,
                  [this.dataForChart]: _.sumBy(data, this.dataForChart)
                }))
        ))
                .value()
        obgOp.map(d => {
          map(d, (data, index) => {
            this.labelStacked.push(`${data[this.label2ForChart]} - ${data[this.dataForChart]}`)
            this.dataStacked.push(data[this.dataForChart])
          })
        })

        var $employ_obj_type_barchar_data = {
          labels: Object.keys(arr_level1),
          datasets: []
        };
        let secondLabel = this.label2ForChart
        let firstLabel = this.labelForChart
        let dataForStacked = this.dataForChart
        forEach(groupBy(arr, secondLabel), function (key, value) {
          var $data = Array(Object.keys(arr_level1).length).fill(0);
          forEach(groupBy(key, firstLabel), function (_key, _index) {
            if (_key.length > 0) {
              $data[Object.keys(arr_level1).indexOf(_index)] = _.sumBy(_key, dataForStacked)
            } else {
              $data[Object.keys(arr_level1).indexOf(_index)] = _key.length;
            }
          })
          $employ_obj_type_barchar_data.datasets.push({
            label: value,
            data: $data,
            backgroundColor: Charts.colors.theme[Charts.setOrder[$employ_obj_type_barchar_data.datasets.length]]
          })
        })
        this.datacollectionByStacked = $employ_obj_type_barchar_data


        ans.map( (d, n) => {
          this.label.push(`${d[this.labelForChart]} - ${d[this.dataForChart]}`)
          this.labellabel.push(d[this.labelForChart])
          this.data.push(d[this.dataForChart])
        })
        this.dataByLine = {
          labels: this.label,
          datasets: [
            {
              label: this.dataForChart,
              data: this.data,
              backgroundColor: '#f87979',
              datalabels: {
                align: 'end',
                anchor: 'end'
              }
            },
          ]
        }
        this.optionsByLine = {
          responsive: true,
          plugins: {
            datalabels: {
              backgroundColor: function(context) {
                return context.dataset.backgroundColor;
              },
              borderRadius: 4,
              color: 'white',
              font: {
                weight: 'bold'
              },
              formatter: Math.round
            }
          },
          scales: {
            yAxes: [{
              stacked: true
            }]
          }
        }
        this.datacollection = {
          labels: this.label,
          datasets: [
            {
              label: this.dataForChart,
              data: this.data,
              backgroundColor: this.colors
            }
          ]
        }
        this.options = {
          responsive: true,
          tooltips: {
            enabled: true,
            callbacks: {
              label: ((tooltipItems, data) => {
                return data['labels'][tooltipItems['index']]
              })
            }
          },
          plugins: {
            datalabels: {
              color: 'white',
              display: function(context) {
                return context.dataset.data[context.dataIndex] > 15;
              },
              font: {
                weight: 'bold'
              },
              formatter: Math.round
            }
          }
        }

        this.optionsByStacked = {
          responsive: true,
          scales: {
            xAxes: [{
              stacked: true,
              categoryPercentage: 0.5,
              barPercentage: 1.5
            }],
            yAxes: [{
              stacked: true,
            }]
          },
          plugins: {
            datalabels: {
              display: function(context) {
                return context.dataset.data[context.dataIndex] > 15;
              },
              color: 'white',
              font: {
                weight: 'bold'
              },
              formatter: Math.round
            }
          }
        }
        this.optionsByBar = {
          scales: {
            xAxes: [{
              ticks: {
                autoSkip: false
              }
            }]
          },
          responsive: true,
          tooltips: {
            enabled: true,
            callbacks: {
              label: ((tooltipItems, data) => {
                return ''
              })
            }
          },
          plugins: {
            datalabels: {
              color: 'white',
              font: {
                weight: 'bold'
              },
              formatter: Math.round
            }
          }
        }
        this.optionsByMultiple = {
          responsive: true,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: false
              }
            }],
            xAxes: [{
              ticks: {
                autoSkip: false,
                beginAtZero: true,
              },
              barPercentage: 0.8,
              categoryPercentage: 1.0
            }]
          },
          plugins: {
            datalabels: {
              align: 'center',
              anchor: 'center',
              font: { weight: 'bold' }
            }
          }
        }
      },
      filterByDropdown () {
        let obj = {}

        this.reportData.map(emp => {

          obj = Object.keys(emp)

        })

        this.labelNewForChart.push(obj)
        this.dataNewForChart.push(obj)
      },
      fillData(event) {
        if (this.colors.length < this.rData.length) {
          let count = this.rData.length - this.colors.length
          let color = randomColor({
            count: count,
            luminosity: 'light',
            hue: 'random'
          })
          this.colors = this.colors.concat(color)
        }

        this.label = []
        this.labelStacked = []
        this.data = []
        this.dataStacked = []
        this.background = []
        let arr = this.reportData
        var chartSettings = {}
        if (!this.label2ForChart) {
          chartSettings = {
            type: this.chartType,
            label: this.labelForChart,
            data: this.dataForChart
          }
        } else {
          chartSettings = {
            type: this.chartType,
            label: this.labelForChart,
            data: this.dataForChart,
            label2: this.label2ForChart,
          }
        }

        var Charts = {
          setOrder: [
            'danger', 'default', 'success',
            'primary', 'info', 'secondary',
            'first', 'second', 'four', 'five',
            'six', 'seven', 'nine', 'ten',
            'info2', 'info3', 'info4'
          ],
          // Colors
          colors: {
            theme: {
              'default': '#ff9f40',
              'primary': '#36a2eb',
              'secondary': '#ff6384',
              'info': '#ffcd56',
              'success': '#4bc0c0',
              'danger': '#6f40fe',
              'first': '#fe85d0',
              'second': '#f7febd',
              'four': '#65fef2',
              'five': '#fee0f2',
              'six': '#03feb7',
              'seven': '#c9fe91',
              'nine': '#a465fe',
              'ten': '#3f2cfe',
              'info2': '#fea8ab',
              'info3': '#fe8d61',
              'info4': '#9c0965'
            }
          }
        }
        const ans = _(arr).groupBy(this.labelForChart)
                .map((platform, n) => ({
                  [this.labelForChart]: n,
                  [this.dataForChart]: _.sumBy(platform, this.dataForChart)
                }))
                .value()
        let arr_level1 = groupBy(arr, this.labelForChart)
        let arr_level2 = map(arr_level1, d => {
          return groupBy(d, this.label2ForChart)
        })
        let obgOp = _(arr_level2).map((outer, inner) => (
                map(outer, (data, label) => ({
                  [this.label2ForChart]: label,
                  [this.dataForChart]: _.sumBy(data, this.dataForChart)
                }))
        ))
                .value()
        obgOp.map(d => {
          map(d, (data, index) => {
            this.labelStacked.push(`${data[this.label2ForChart]} - ${data[this.dataForChart]}`)
            this.dataStacked.push(data[this.dataForChart])
          })
        })

        var $employ_obj_type_barchar_data = {
          labels: Object.keys(arr_level1),
          datasets: []
        };
        let secondLabel = this.label2ForChart
        let firstLabel = this.labelForChart
        let dataForStacked = this.dataForChart
        forEach(groupBy(arr, secondLabel), function (key, value) {
          var $data = Array(Object.keys(arr_level1).length).fill(0);
          forEach(groupBy(key, firstLabel), function (_key, _index) {
            if (_key.length > 0) {
              $data[Object.keys(arr_level1).indexOf(_index)] = _.sumBy(_key, dataForStacked)
            } else {
              $data[Object.keys(arr_level1).indexOf(_index)] = _key.length;
            }
          })
          $employ_obj_type_barchar_data.datasets.push({
            label: value,
            data: $data,
            backgroundColor: Charts.colors.theme[Charts.setOrder[$employ_obj_type_barchar_data.datasets.length]]
          })
        })
        this.datacollectionByStacked = $employ_obj_type_barchar_data


        ans.map( (d, n) => {
          this.label.push(`${d[this.labelForChart]} - ${d[this.dataForChart]}`)
          this.labellabel.push(d[this.labelForChart])
          this.data.push(d[this.dataForChart])
        })
        this.dataByLine = {
          labels: this.label,
          datasets: [
            {
              label: this.dataForChart,
              data: this.data,
              backgroundColor: '#f87979',
              datalabels: {
                align: 'end',
                anchor: 'end'
              }
            },
          ]
        }
        this.optionsByLine = {
          plugins: {
            datalabels: {
              backgroundColor: function(context) {
                return context.dataset.backgroundColor;
              },
              borderRadius: 4,
              color: 'white',
              font: {
                weight: 'bold'
              },
              formatter: Math.round
            }
          },
          scales: {
            yAxes: [{
              stacked: true
            }]
          }
        }
        this.datacollection = {
          labels: this.label,
          datasets: [
            {
              label: this.dataForChart,
              data: this.data,
              backgroundColor: this.colors
            }
          ]
        }
        this.options = {
          tooltips: {
            enabled: true,
            callbacks: {
              label: ((tooltipItems, data) => {
                return data['labels'][tooltipItems['index']]
              })
            }
          },
          plugins: {
            datalabels: {
              color: 'white',
              display: function(context) {
                return context.dataset.data[context.dataIndex] > 15;
              },
              font: {
                weight: 'bold'
              },
              formatter: Math.round
            }
          }
        }

        this.optionsByStacked = {
          scales: {
            xAxes: [{
              stacked: true,
              categoryPercentage: 0.5,
              barPercentage: 1.5
            }],
            yAxes: [{
              stacked: true,
            }]
          },
          plugins: {
            datalabels: {
              display: function(context) {
                return context.dataset.data[context.dataIndex] > 15;
              },
              color: 'white',
              font: {
                weight: 'bold'
              },
              formatter: Math.round
            }
          }
        }
        this.optionsByBar = {
          tooltips: {
            enabled: true,
            callbacks: {
              label: ((tooltipItems, data) => {
                return ''
              })
            }
          },
          plugins: {
            datalabels: {
              color: 'white',
              font: {
                weight: 'bold'
              },
              formatter: Math.round
            }
          }
        }
      },
      setActive (activeChart) {
        for (let type of this.chartTypes) {
          $(`#tab-${type}${this.chartId}`).removeClass('active')
        }

        this.chartType = activeChart
        this.isPie = (activeChart === 'pie') ? true : false
        this.isDonut = (activeChart === 'donut') ? true : false
        this.isBar = (activeChart === 'bar') ? true : false
        this.isStacked = (activeChart === 'stacked') ? true : false
        this.isLine = (activeChart === 'line') ? true : false
        this.isMultiple = (activeChart === 'multiple') ? true : false

        db.chart.setActiveChartType(this.chartId, this.chartType)
      }
    },
    async created () {
      // if (!this.$can('all', 'Admin')) this.$router.push('/home')

      const chartOptions = await db.chart.readOptions(this.chartId)
      this.chartType = chartOptions.type
      this.dataForChart = chartOptions.data
      this.labelForChart = chartOptions.label
      this.label2ForChart = chartOptions.label2
    },
    mounted () {
      $(`#tab-${this.chartType}${this.widgetKey}`)
        .parent()
        .find('nav-link')
        .addClass('active')

      this.filterByDropdown()
      this.loadData()
    }
  }
</script>

<style lang="scss">
  .chartWidget {
    .panel-tabs {
      > li {
        float: left;
        margin-bottom: -1px;
        padding: 0 5px;
        > a {
          margin-right: 2px;
          margin-top: 4px;
          line-height: .85;
          border: 1px solid transparent;
          border-radius: 4px 4px 0 0;
          color: #333;
          padding: 5px;
          &:hover,
          &:focus {
            border-color: transparent;
            color: #002c68;
            background-color: transparent;
          }
        }
        &.active > a,
        &.active > a:hover,
        &.active > a:focus
        {
          color: #002c68;
          cursor: default;
          -webkit-border-radius: 2px;
          -moz-border-radius: 2px;
          border-radius: 2px;
          background-color: rgba(211, 208, 208, 0.95);
          border-bottom-color: transparent;
        }
      }
    }
    .tab-content {
      height: 500px;
    }
    .select-label-data {
      width: 100%;
      padding: 0 5px;
      border-radius: 5px;
      border: 1px solid #11cdef;;
      outline: none;
    }
    .dashboard__tabsWrapper .nav {
      box-shadow: none !important;
    }
    .panel-primary > .panel-heading {
      color: #fff;
      background-color: #eceff2de;
      border-color: #428bca;
      border-radius: 5px;
    }
    .nav {
      padding: 5px;
      margin-bottom: 0;
      list-style: none;
    }
    .panel-heading {
      height: 35px;
    }

    &__chartWrapper {
      position: relative;
      height: 50%;
      width: 50%;
      margin: 0 auto;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Chart/index.vue